export const TESTIDS = {
  // global
  langToggle: "lang-toggle",
  navHome: "nav-home",
  navAbout: "nav-about",
  navProjects: "nav-projects",
  navJournal: "nav-journal",
  navContact: "nav-contact",
  navBooking: "nav-booking",
  brandLogo: "brand-logo",
  mobileMenuToggle: "mobile-menu-toggle",
  newsletterInput: "newsletter-input",
  newsletterSubmit: "newsletter-submit",
  newsletterSuccess: "newsletter-success",

  // home
  homeHero: "home-hero",
  homeCtaPrimary: "home-cta-primary",
  homeCtaGhost: "home-cta-ghost",
  homeManifesto: "home-manifesto",
  homePillars: "home-pillars",
  homeUniverse: "home-universe",
  homeAboutTeaser: "home-about-teaser",
  homeFooterCta: "home-footer-cta",

  // about
  aboutHero: "about-hero",
  aboutChapter: (n) => `about-chapter-${n}`,
  aboutCta: "about-cta",

  // projects
  projectsHero: "projects-hero",
  projectsRoomActive: "projects-room-active",
  projectsRoomSoon: "projects-room-soon",
  projectsRoomVision: "projects-room-vision",
  projectCard: (id) => `project-${id}`,
  projectLink: (id) => `project-${id}-link`,

  // contact
  contactHero: "contact-hero",
  contactForm: "contact-form",
  contactName: "contact-name",
  contactEmail: "contact-email",
  contactTopic: "contact-topic",
  contactMessage: "contact-message",
  contactSubmit: "contact-submit",
  contactSuccess: "contact-success",
  contactError: "contact-error",
  bookingOpen: "booking-open",
  bookingForm: "booking-form",
  bookingName: "booking-name",
  bookingEmail: "booking-email",
  bookingPhone: "booking-phone",
  bookingProjectType: "booking-project-type",
  bookingDate: "booking-date",
  bookingNotes: "booking-notes",
  bookingSubmit: "booking-submit",
  bookingSuccess: "booking-success",
  bookingClose: "booking-close",

  // journal
  journalHero: "journal-hero",
  journalNotify: "journal-notify",
};
